export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export const isValidSubdomain = (subdomain: string): boolean => {
  const subdomainRegex = /^[a-z0-9-]+$/
  return subdomainRegex.test(subdomain)
}

export const isValidSubdomainRealtime = (subdomain: string): boolean => {
  const subdomainRealtimeRegex = /^[a-z0-9-]*$/
  return subdomainRealtimeRegex.test(subdomain)
}
